export function ErrorRoute() {

    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>The requested page was not found.</p>
        </div>
    );
}
